/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
define(['config/language/validator',
    'config/geopolView/validator',
    './utils'],
function(localeValidator, geopolViewValidator, utils) {
    'use strict';

    var roadUseValues = ['LimitedAccess', 'Arterial', 'Terminal', 'Ramp', 'Rotary', 'LocalStreet'],

        routingGuidanceLanguageValues = [
            'ar', 'af-ZA', 'bg-BG', 'zh-TW', 'cs-CZ', 'da-DK', 'nl-NL', 'en-GB', 'en-US', 'fi-FI', 'fr-FR',
            'de-DE', 'el-GR', 'hu-HU', 'id-ID', 'it-IT', 'ko-KR', 'lt-LT', 'ms-MY', 'nb-NO', 'pl-PL',
            'pt-BR', 'pt-PT', 'ru-RU', 'sk-SK', 'sl-SI', 'es-ES', 'es-MX', 'sv-SE', 'th-TH', 'tr-TR'
        ],

        trafficIncidentsLanguageValues = [
            'ca', 'cs', 'da', 'de', 'en', 'es', 'fi', 'fr', 'hu', 'it', 'nl', 'no', 'pl', 'pt', 'sk', 'sv', 'tr'
        ],

        // Up-to-date list available on:
        // https://developer.tomtom.com/online-search/online-search-documentation/supported-languages
        supportedLanguageCodes = [
            'af-ZA', 'ar', 'bg-BG', 'ca-ES', 'zh-CN', 'zh-TW', 'cs-CZ', 'da-DK', 'nl-BE', 'nl-NL', 'en-AU', 'en-NZ',
            'en-GB', 'en-US', 'et-EE', 'fi-FI', 'fr-CA', 'fr-FR', 'de-DE', 'el-GR', 'hr-HR', 'hu-HU', 'it-IT',
            'lv-LV', 'lt-LT', 'ms-MY', 'no-NO', 'pl-PL', 'pt-BR', 'pt-PT', 'ru-RU', 'sk-SK', 'sl-SI', 'es-ES',
            'es-419', 'sv-SE', 'tr-TR'
        ];

    function isDateRfc3339(dateString) {
        return dateString.toString()
            .match(/(\d\d\d\d)(-)?(\d\d)(-)?(\d\d)(T)?(\d\d)(:)?(\d\d)(:)?(\d\d)(\.\d+)?(Z|([+-])(\d\d)(:)?(\d\d))/);
    }

    function validateAgainstSetOfValues(value, arrayOfValues, messageIfNotFound) {
        if (arrayOfValues.indexOf(value) === -1) {
            throw new TypeError(messageIfNotFound);
        }
        return value;
    }

    function hasBoundingBoxFields(bbox) {
        return bbox.hasOwnProperty('minLon') && bbox.hasOwnProperty('maxLon') &&
            bbox.hasOwnProperty('minLat') && bbox.hasOwnProperty('maxLat');
    }

    function checkBBoxNormalized(bbox) {
        return parseFloat(bbox.maxLat) <= parseFloat(bbox.minLat) || parseFloat(bbox.maxLon) <= parseFloat(bbox.minLon);
    }

    function checkInteger(value) {
        return !isFinite(value) || value % 1 !== 0;
    }

    function checkIntegerInInterval(value, min, max) {
        return checkInteger(value) || value <= min || value > max;
    }

    function checkFloatInInterval(numValue, min, max) {
        return !isFinite(numValue) || numValue < min || numValue > max;
    }

    function checkArray(array) {
        return array.constructor.toString().indexOf('Array') < 0;
    }

    function throwTypeErrorWhen(condition, message) {
        if (condition) {
            throw new TypeError(message);
        }
    }

    function isPointValid(point) {
        if (!utils.isString(point) || !utils.pointRegex.test(point)) {
            throw new TypeError('A point is expected, but ' + point + ' [' + typeof value + '] given');
        }
        return true;
    }

    function checkLongitude(value) {
        var numValue = parseFloat(value);
        if (checkFloatInInterval(numValue, -180, 180)) {
            throw new TypeError('an longitude <-180,180> is expected, but ' +
                value + ' [' + typeof value + '] given');
        }
        return numValue;
    }

    function checkLatitude(value) {
        var numValue = parseFloat(value);
        if (checkFloatInInterval(numValue, -90, 90)) {
            throw new TypeError('an latitude <-90,90> is expected, but ' + value + ' [' + typeof value + '] given');
        }
        return numValue;
    }

    function checkPointObjectOrArray(point) {
        var lat, lon;
        if (Array.isArray(point)) {
            if (!(point.length === 2 && point.filter(isFinite).length === 2)) {
                throw new TypeError('Ivalid point array in route points');
            }
            lat = point[0];
            lon = point[1];
        } else {
            if (!(isFinite(point.lat) && (isFinite(point.lon) || isFinite(point.lng)))) {
                throw new TypeError('Ivalid point object in route points');
            }
            lat = point.lat;
            lon = typeof point.lon !== 'undefined' ? point.lon : point.lng;
        }

        if (!(typeof lat === 'number' || lat instanceof Number) ||
            !(typeof lon === 'number' || lon instanceof Number)) {
            throw new TypeError('Lat and lon components of point should be finite numbers');
        }

        checkLongitude(lon);
        checkLatitude(lat);
    }

    return {

        /**
         * @ignore
         * Casts to boolean
         * @param {*} value
         * @return {Boolean} casted value
         */
        bool: function(value) {
            return value === 'false' ? false : Boolean(value);
        },

        /**
         * @ignore
         * Check whether the given parameter is a float number
         * @param {*} value The value
         * @return {Number} value
         * @throws {TypeError} for invalid parameter
         */
        number: function(value) {
            var numValue = parseFloat(value);
            if (!isFinite(numValue)) {
                throw new TypeError('a number is expected, but ' + value + ' [' + typeof value + '] given');
            }
            return numValue;
        },

        /**
         * @ignore
         * Check whether the given parameter is a integer greater than or equal 0
         * @param {*} value The value
         * @return {Number} value
         * @throws {TypeError} for invalid parameter
         */
        naturalInteger: function(value) {
            var numValue = parseFloat(value);
            if (checkInteger(numValue) || numValue < 0) {
                throw new TypeError('a natural integer (greater than or equal 0) is expected, but ' +
                    value + ' [' + typeof value + '] given');
            }
            return numValue;
        },

        /**
         * @ignore
         * Check whether the given parameter is a integer greater than 0
         * @param {*} value The value
         * @return {Number} value
         * @throws {TypeError} for invalid parameter
         */
        positiveInteger: function(value) {
            var numValue = parseFloat(value);
            if (checkInteger(numValue) || numValue <= 0) {
                throw new TypeError('a positive integer (greater than 0) is expected, but ' +
                    value + ' [' + typeof value + '] given');
            }
            return numValue;
        },

        integer: function(value) {
            var numValue = parseFloat(value);
            if (checkInteger(numValue)) {
                throw new TypeError('an integer is expected, but ' + value + ' [' + typeof value + '] given');
            }
            return numValue;
        },

        /**
         * @ignore
         * Check whether the given parameter is a longitude and casts to proper interval <-180, 180>
         * @param {*} value
         * @return {Number} value
         * @throws {TypeError} for invalid parameter
         */
        longitude: checkLongitude,

        /**
         * @ignore
         * Check whether the given parameter is a latitude and casts to proper interval <-90, 90>
         * @param {*} value
         * @return {Number} value
         * @throws {TypeError} for invalid parameter
         */
        latitude: checkLatitude,

        /**
         * @ignore
         * Check whether the given parameter is a valid bounding box. Allows to contain whole world and a half on each
         * side.
         * @param {*} bbox The bounding box
         * @return {Object} bbox
         * @throws {TypeError} for invalid parameter
         */
        boundingBox: function(bbox) {
            throwTypeErrorWhen(!hasBoundingBoxFields(bbox),
                'a bounding box is expected, but ' + bbox + ' [' + typeof bbox + '] given');

            throwTypeErrorWhen(checkFloatInInterval(bbox.minLat, -90, 90),
                'a bounding box minimal latitude is expected ' + bbox.minLat + ' [' + typeof bbox.minLat + '] given');

            throwTypeErrorWhen(checkFloatInInterval(bbox.maxLat, -90, 90),
                'a bounding box maximal latitude is expected ' + bbox.maxLat + ' [' + typeof bbox.maxLat + '] given');

            throwTypeErrorWhen(checkFloatInInterval(bbox.minLon, -270, 180),
                'a bounding box minimal longitude is expected ' + bbox.minLon + ' [' + typeof bbox.minLon + '] given');

            throwTypeErrorWhen(checkFloatInInterval(bbox.maxLon, -180, 270),
                'a bounding box maximal longitude is expected ' + bbox.maxLon + ' [' + typeof bbox.maxLon + '] given');

            throwTypeErrorWhen(checkBBoxNormalized(bbox), 'a bounding box expected but max <= min');

            return bbox;
        },

        /**
         * @ignore
         * Check whether the given parameter is a float number in proper interval <min, max>
         * @example
         * var numberBetweenMinusFiveAndFive = validators.numberInInterval(-5,5);
         * numberBetweenMinusFiveAndFive(-10); // false
         * numberBetweenMinusFiveAndFive(3); //true
         *
         * @param {Number} [min] The minimal value
         * @param {Number} [max] The maximal value
         * @return {Function} validator function that checks type and value range
         * @throws {TypeError} when missing min or max value
         */
        numberInInterval: function(min, max) {
            if (arguments.length !== 2) {
                throw new TypeError('Number in interval validator requires min and max value parameters');
            }
            return function(value) {
                var numValue = parseFloat(value);
                if (checkFloatInInterval(numValue, min, max)) {
                    throw new TypeError('a number in interval <' + min + ', ' + max + '> is expected, but ' +
                        value + ' [' + typeof value + '] given');
                }
                return numValue;
            };
        },

        /**
         * @ignore
         * Check whether the given parameter is an integer number in proper interval <min, max>
         * @example
         * var numberBetweenMinusFiveAndFive = validators.numberInInterval(-5,5);
         * numberBetweenMinusFiveAndFive(-10); // false
         * numberBetweenMinusFiveAndFive(3); //true
         *
         * @param {Number} [min] The minimal value
         * @param {Number} [max] The maximal value
         * @return {Function} validator function that checks type and value range
         * @throws {TypeError} when missing min or max value
         */
        integerInInterval: function(min, max) {
            if (arguments.length !== 2) {
                throw new TypeError('Number in interval validator requires min and max value parameters');
            }
            return function(value) {
                var numValue = parseFloat(value);
                if (checkIntegerInInterval(numValue, min, max)) {
                    throw new TypeError('an integer in interval <' + (min + 1) + ', ' + max + '> is expected, but ' +
                        value + ' [' + typeof value + '] given');
                }
                return numValue;
            };
        },

        /**
         * @ignore
         * Check whether the given parameter is a string
         * @param {String} string
         * @return {String} value
         * @throws {TypeError} for non strings
         */
        string: function(string) {
            if (!utils.isString(string)) {
                throw new TypeError('a string is expected, but ' + string + ' [' + typeof string + '] given');
            }
            return string;
        },

        /**
         * @ignore
         * Check whether the given parameter is a zoom level (0, 18>
         * @param {Number} zoomLevel
         * @return {Number} value
         * @throws {TypeError} for non invalid parameter
         */
        zoomLevel: function(zoomLevel) {
            var numZoomLevel = parseFloat(zoomLevel);
            if (checkFloatInInterval(numZoomLevel, 0, 18)) {
                throw new TypeError('an zoom level (0, 18> is expected, but ' + zoomLevel +
                    ' [' + typeof zoomLevel + '] given');
            }
            return numZoomLevel;
        },

        /**
         * @ignore
         * Check whether the given parameter is a function
         * @param {Function} fun
         * @return {Function} fun
         * @throws {TypeError} for non function
         */
        functionType: function(fun) {
            if (typeof fun !== 'function') {
                throw new TypeError('a function is expected, but ' + fun + '  [' + typeof fun + '] given');
            }
            return fun;
        },

        /**
         * @ignore
         * Checks whether the given country name uses ISO 3166 alpha-3 or alpha-2 format.
         * @param {String} name
         * @return {String} name
         * @throws {TypeError} if the country name is not valid
         */
        countryCode: function(name) {
            if (!(utils.isString(name) && (name.length === 3 || name.length === 2))) {
                throw new TypeError('a 2 or 3-characters long country name is expected, but ' + name +
                    ' [' + typeof name + '] given');
            }
            return name;
        },

        /**
         * @ignore
         * Checks whether the given language code belongs to predefined set of supported language codes
         * which is a subset of the IETF language tags.
         * @param {String|undefined} langCode
         * @return {String}
         */
        languageCode: function(langCode) {
            if (!utils.isString(langCode) || supportedLanguageCodes.indexOf(langCode) < 0) {
                throw new TypeError('One of pre-defined language codes was expected: ' + supportedLanguageCodes +
                    ', but ' + langCode + ' [' + typeof langCode + '] given');
            }
            return langCode;
        },

        /**
         * @ignore
         * Checks whether the given country name's list use ISO 3166 alpha-3 or alpha-2 format.
         * @param {String|Array} value
         * @return {String} list
         * @throws {TypeError} if one of the country names is not valid
         */
        countrySet: function(value) {
            var stringValue;
            throwTypeErrorWhen(!utils.isString(value) && checkArray(value),
                'An array of string country names or string (divided with commas) of country ' +
                'names (two or three-characters long) is expected, but ' + value + ' [' + typeof value + '] given');

            stringValue = utils.isString(value) ? value : value.join();
            throwTypeErrorWhen(!stringValue.match(/^([a-zA-z]{2,3},)*[a-zA-z]{2,3}$/),
                'An array of string country names or string (divided with commas) of country ' +
                'names (two or three-characters long) is expected, but ' + value + ' [' + typeof value + '] given');

            return stringValue;
        },

        /**
         * @ignore
         * Checks whether the given country name's list use ISO 3166 alpha-3 or alpha-2 format.
         * @param {Boolean} allowEmpty Specifies that it allows empty array as a valid value
         * @param {String|Array} value
         * @return {String} list
         * @throws {TypeError} if one of the country names is not valid
         */
        countrySetAlpha3: function(allowEmpty, value) {
            var stringValue;
            throwTypeErrorWhen(!utils.isString(value) && checkArray(value),
                'An array of string country names or string (divided with commas) of country ' +
                'names (three-characters long) is expected, but ' + value + ' [' + typeof value + '] given');

            stringValue = utils.isString(value) ? value : value.join();
            if (allowEmpty && stringValue === '') {
                return value;
            }
            throwTypeErrorWhen(!stringValue.match(/^([a-zA-z]{3},)*[a-zA-z]{3}$/),
                'An array of string country names or string (divided with commas) of country ' +
                'names (three-characters long) is expected, but ' + value + ' [' + typeof value + '] given');

            return value;
        },

        /**
         * @ignore
         * Checks whether the given point is in proper format
         * @param {String} value
         * @return {String} value
         * @throws {TypeError} if the given value is in not valid format
         */
        point: function(value) {
            isPointValid(value);
            return value;
        },

        /**
         * @ignore
         * Check whether the given parameter is a positive integer (greater than 0) and lower than 3
         * @param {Number} value The value
         * @return {Number} value
         * @throws {TypeError} for invalid parameter
         */
        fuzzinessLevel: function(value) {
            var numValue = parseFloat(value);
            if (checkIntegerInInterval(numValue, 0, 4)) {
                throw new TypeError('Fuzziness level value (a positive integer lower than 5) is expected, but ' +
                    value + ' [' + typeof value + '] given');
            }
            return numValue;
        },

        /**
         * @ignore
         * Check whether the given parameter is a positive integer (greater than 0) and lower than 100
         * @param {Number} value The value
         * @return {Number} value
         * @throws {TypeError} for invalid parameter
         */
        limit: function(value) {
            var numValue = parseFloat(value);
            if (checkIntegerInInterval(numValue, 0, 100)) {
                throw new TypeError('Limit value (a positive integer lower than 100) is expected, but ' +
                    value + ' [' + typeof value + '] given');
            }
            return numValue;
        },

        /**
         * @ignore
         * Check whether the given parameter is an offset - positive integer <0, 1900>
         * @param {Number} value The value
         * @return {Number} value
         * @throws {TypeError} for invalid parameter
         */
        offset: function(value) {
            var numValue = parseFloat(value);
            if (checkIntegerInInterval(numValue, -1, 1900)) {
                throw new TypeError('Offset an integer value <0, 1900> is expected, but ' + value +
                    ' [' + typeof value + '] given');
            }
            return numValue;
        },

        /**
         * @ignore
         * Check whether the given parameter is a plain object (array and functions aren't accepted)
         * @param {Object} object
         * @return {Object} object
         * @throws {TypeError} for non object
         */
        plainObject: function(object) {
            if (typeof object !== 'object' || object.constructor !== Object) {
                throw new TypeError('an object is expected, but ' + object + '  [' + typeof object + '] given');
            }
            return object;
        },

        /**
         * @ignore
         * Check whether the given parameter is an array (objects and functions aren't accepted)
         * @param {Array} array
         * @return {Array} array
         * @throws {TypeError} for non array
         */
        arrayType: function(array) {
            if (checkArray(array)) {
                throw new TypeError('an array is expected, but ' + array + '  [' + typeof array + '] given');
            }
            return array;
        },

        arrayOf: function(options) {
            return function(values) {
                values.forEach(function(value) {
                    var key;
                    for (key in options) {
                        if (options.hasOwnProperty(key)) {
                            if (value.hasOwnProperty(key) && typeof options[key].validator === 'function') {
                                value[key] = options[key].validator(value[key]);
                            }

                            if (options[key].required === true && !value.hasOwnProperty(key)) {
                                throw new Error('Missing required ' + key);
                            }
                        }
                    }
                });
                return values;
            };
        },

        objectOf: function(options) {
            return function(value) {
                var key;
                for (key in options) {
                    if (options.hasOwnProperty(key)) {
                        if (value.hasOwnProperty(key) && typeof options[key].validator === 'function') {
                            value[key] = options[key].validator(value[key]);
                        }
                        if (options[key].required === true && !value.hasOwnProperty(key)) {
                            throw new Error('Missing required ' + key);
                        }
                    }
                }
                return value;
            };
        },

        roadUse: function(value) {
            var elements, i;
            throwTypeErrorWhen(!utils.isString(value) || !value.match(/^\[("\w*",?)+\]$/),
                'Road use is expected, but ' + value + '  [' + typeof value + '] given');

            elements = value.replace(/["[\]]/g, '').split(',');
            for (i = 0; i < elements.length; i += 1) {
                throwTypeErrorWhen(roadUseValues.indexOf(elements[i]) < 0,
                    'Road use (' + roadUseValues + ') is expected, but ' + value +
                    '  [' + typeof value + '] given');
            }
            return value;
        },

        oneOfValue: function(values, paramName) {
            return function(value) {
                var message = 'Supported ' + paramName + ' is expected (one of: ' + values + '), but ' + value +
                    ' [' + typeof value + '] given';
                return validateAgainstSetOfValues(value, values, message);
            };
        },

        arrayOfValues: function(values, paramName) {
            return function(value) {
                var i;
                var message = 'Supported ' + paramName + ' type is expected (array with one of: ' + values +
                    '), but ' + value + ' [' + typeof value + '] given';
                if (checkArray(value)) {
                    throw new TypeError('an array is expected, but ' + value + '  [' + typeof value + '] given');
                }
                for (i = 0; i < value.length; i += 1) {
                    validateAgainstSetOfValues(value[i], values, message);
                }
                return value;
            };
        },

        /**
         * @ignore
         * Checks whether the given departure time is now or in proper rfc3339 format ( 1996-12-19T16:39:57 or
         * 1996-12-19T16:39:57-08:00 ):
         * @param {String} value
         * @return {String} value
         * @throws {TypeError} if the given value is not valid
         */
        departAt: function(value) {
            if (value === 'now' || isDateRfc3339(value) && Date.now() < Date.parse(value)) {
                return value;
            } else {
                throw new TypeError('Supported departAt is now or rfc3339 format and no earlier than now(), but ' +
                    value + ' [' + typeof value + '] given');
            }
        },

        /**
         * @ignore
         * Checks whether the given arrive time is in proper rfc3339 format ( 1996-12-19T16:39:57 or
         * 1996-12-19T16:39:57-08:00 ):
         * @param {String} value
         * @return {String} value
         * @throws {TypeError} if the given value is not valid
         */
        arriveAt: function(value) {
            if (isDateRfc3339(value) && Date.now() < Date.parse(value)) {
                return value;
            } else {
                throw new TypeError('Supported arriveAt is rfc3339 format, but and no earlier than now() ' +
                    value + ' [' + typeof value + '] given');
            }
        },

        routingGuidanceLanguage: function(value) {
            var message = 'Supported routing guidance language is expected to be one of: ' +
                routingGuidanceLanguageValues + '), but ' + value + ' [' + typeof value + '] given';
            return validateAgainstSetOfValues(value, routingGuidanceLanguageValues, message);
        },

        trafficIncidentsLanguage: function(value) {
            var message = 'Supported traffic incidents language is expected to be one of: ' +
                trafficIncidentsLanguageValues + '), but ' + value + ' [' + typeof value + '] given';
            return validateAgainstSetOfValues(value, trafficIncidentsLanguageValues, message);
        },

        /**
         * @ignore
         * Checks whether the given routing locations is in proper format:
         * circle A circle with a center point and a radius (in meters).
         * The radius must be a positive integer with the maximum value of 20050000. Note that larger integer values
         * will not be rejected but lowered to the maximum value. circle(52.37245,4.89406,10000) location    A point or
         * a circle.
         * 52.37245,4.89406
         * circle(52.37245,4.89406,10000)
         * @param {String} value
         * @return {String} value
         * @throws {TypeError} if the given value is not valid
         */
        routingLocations: function(value) {
            var point = utils.pointRegex,
                circle = utils.circleRegex,
                routingLocation;

            if (value.constructor.toString().indexOf('Array') > -1) {
                value = value.join(':');
            }

            routingLocation = new RegExp('^' + point.source + ':(?:(?:' + point.source + '|' +
                circle.source + '):)*' + point.source + '$');
            if (!value.match(routingLocation)) {
                throw new TypeError('Routing location is expected. But ' + value + ' [' + typeof value + '] given');
            }
            return value;
        },

        /**
         * @ignore
         * Checks whether the given input is in proper circle format:
         * circle A circle with a center point and a radius (in meters).
         * The radius must be a positive integer with the maximum value of 20050000. Note that larger integer values
         * will not be rejected but lowered to the maximum value. circle(52.37245,4.89406,10000)
         * @param {String} value
         * @return {String} value
         * @throws {TypeError} if the given value is not valid
         */
        circle: function(value) {
            var match;
            throwTypeErrorWhen(!utils.isString(value),
                'Expecting circle but ' + value + ' [' + typeof value + '] given');

            match = value.match(/circle\(-?\d*(?:\.\d*)?\s*,\s*-?\d*(?:\.\d*)?\s*,\s*(\d+)\)/);
            throwTypeErrorWhen(!match || parseFloat(match[1]) > 20050000,
                'Expecting circle but ' + value + ' [' + typeof value + '] given');

            return value;
        },

        /**
         * @ignore
         * Checks whether the given input is in proper geometry list format.
         * Geometry list represents list of figures (polygons or circles) objects.
         * Circle contains properties like: type ("CIRCLE"), position (lat & lon) and radius.
         * Polygon contains properties like: type ("POLYGON") and vertices (as a list of points).
         *
         * @param {Array} value
         * @return {Array} value
         * @throws {TypeError} if the given value is not valid
         */
        geometryList: function(value) {
            var i, geoObject;
            throwTypeErrorWhen(checkArray(value), 'An array of geometry objects is expected, but ' +
                value + ' [' + typeof value + '] given');

            if (value.length > 0) {
                for (i = 0; i < value.length; i += 1) {
                    geoObject = value[i];
                    throwTypeErrorWhen(!geoObject.hasOwnProperty('type') ||
                        !geoObject.hasOwnProperty('vertices') &&
                        (!geoObject.hasOwnProperty('position') || !geoObject.hasOwnProperty('radius')),
                    'An array of geometry objects is expected, but ' + value + ' [' + typeof value + '] given');
                }
            } else {
                throw new TypeError('An array of geometry objects is expected, but ' + value +
                    ' [' + typeof value + '] given');
            }
            return value;
        },
        locale: function(serviceType) {
            /**
             * @ignore
             * Checks whether provided value is a valid language code for given serviceType
             * @param {String} value language code to be validated
             * @return {String} provided value if it's valid
             * @throws {TypeError} if the given value is not valid
             */
            return function(value) {
                throwTypeErrorWhen(!localeValidator(value, serviceType),
                    'Provided language code "' + value + '" is not valid for a given service type: "' +
                    serviceType + '"');
                return value;
            };
        },
        geopolView: function(value) {
            throwTypeErrorWhen(!geopolViewValidator(value),
                'Provided geopolitical view code "' + value + '" is not valid');
            return value;
        },

        /**
         * @ignore
         *
         * Checks if the given value has a property 'route' which is an array of points.
         * By array of points we mean array of an array of { lat, lon }, { lat, lng }, [ num, num ],
         * L.LatLng objects or mixed.
         *
         * @param {Object} value
         *
         * @return {Object} value Stringified array of figures (JSON format).
         * @throws {TypeError} if the given value is not valid
         */
        route: function(value) {
            var points;

            if (typeof value.points !== 'undefined') {
                points = value.points;
            } else {
                throw new TypeError('Invalid structure of the route object');
            }

            if (points && !(Array.isArray(points) && points.length > 2)) {
                throw new TypeError('Provided route array ' +
                    points + ' is not valid. It should be an array with at least 2 points.');
            }
            points.forEach(checkPointObjectOrArray);
            return value;
        },

        supportingPoints: function(value) {
            if (!utils.isArray(value)) {
                throw new TypeError('Invalid structure of the supporting points');
            }

            if (!value.length || value.length < 2) {
                throw new TypeError('There should be at least two supporting points');
            }
            return value;
        }
    };
});



// WEBPACK FOOTER //
// ./services/validators.js